export enum UserType {
    All = 1,
    Default = 2,
    Trainer = 3,
    Employee = 4
}